module.exports = __webpack_public_path__ + "static/media/ms-icon-310x310.6512b54b.png";